export default {
    data() {
        return {
            isMounted: false,
        };
    },
    mounted() {
        this.isMounted = true;
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/is-mounted/index.js